import { useEffect, useState } from 'react';
import './Background.scss';

const Background = ({ isDarkMode }) => {
  const [showBG, setShowBG] = useState(false);
  const [stars, setStars] = useState([]);

  useEffect(() => {
    // Generate random stars
    const generateStars = () => {
      const newStars = [];
      const starCount = 200;

      for (let i = 0; i < starCount; i++) {
        const size = Math.random() * 3;
        const left = Math.random() * 100;
        const top = Math.random() * 100;
        const delay = Math.random() * 5;
        const duration = 2 + Math.random() * 3;

        newStars.push({
          id: i,
          size,
          left,
          top,
          delay,
          duration
        });
      }

      setStars(newStars);
    };

    generateStars();

    setTimeout(() => {
      setShowBG(true);
    }, 7800);
  }, []);

  return (
    <div className={`background ${isDarkMode ? 'background--night' : 'background--day'} ${showBG ? 'show' : ''}`}>
      {isDarkMode && stars.map(star => (
        <div
          key={star.id}
          className="background__star"
          style={{
            width: `${star.size}px`,
            height: `${star.size}px`,
            left: `${star.left}%`,
            top: `${star.top}%`,
            animationDelay: `${star.delay}s`,
            animationDuration: `${star.duration}s`
          }}
        />
      ))}
    </div>
  );
};

export default Background; 